export default __webpack_public_path__ + "static/sales-a94c160a20a050d8dc5130331f0cb045.png";